import { AbstractSearchCriteria } from './abstract-search-criteria';

export class LocationsSearchCriteria extends AbstractSearchCriteria {
    code: string;
    locationGroupCode: string;
    locationType: string;
    name: string;
    codeOrName: string;
}
